<form
  *ngIf="_userInfo"
  class="form-container"
  name="form"
  (ngSubmit)="f.form.valid && login(_userInfo)"
  #f="ngForm"
  novalidate
>
  <div class="card-content">
    <div class="sent-text">
      {{ 'sms.on.number' | translate }}
      <span class="phone-number">* *** *** {{ _userInfo.smsCodeSendResponse.last4Digits }}</span>
      {{ 'sms.one.time.password.sent' | translate }}
    </div>

    <tax-input
      class="sms-code"
      [class.invalid]="hasError"
      labelText="login.sms.password"
      placeholder="_ _ _ _ _"
      id="password"
      name="password"
      [size]="5"
      [minlength]="5"
      [maxlength]="5"
      [(ngModel)]="password"
      #passwordInput="ngModel"
      [required]="true"
      [autofocus]="true"
      inputStyles="max-width: 80px;"
    ></tax-input>

    <div class="retries grey-text" *ngIf="attemptCount !== undefined">
      <p *ngIf="countdown$ | async as countdown">
        <span *ngIf="countdown !== '0:00'; else tryAgain">
          {{ 'login.try.countdown' | translate }} {{ countdown }}
        </span>
        <ng-template #tryAgain>
          <span
            *ngIf="attemptCount !== 0"
            class="pseudo-link"
            (click)="sendPasswordToUserPhone(_userInfo)"
            translate
          >
            login.sms.again.button
          </span>
        </ng-template>
        <br />
        <br />
        {{ 'login.try' | translate }}: {{ attemptCount }}
      </p>
    </div>

    <div class="bottom">
      <button class="back-button" type="button" (click)="goBack()" translate>group.back</button>
      <button
        class="button_blue"
        type="submit"
        [disabled]="passwordInput.invalid || this.loading"
        translate
      >
        button.continue
      </button>
    </div>
  </div>
</form>
